import React from 'react'

const Privacy = () => {
  return (
    <div>
      <section>
        <div className='container py-5'>
<div className='margin-topall privacy'>
<h1>
Privacy Policy for SMS Zoo Zoo 
</h1>
<p>
This privacy notice for SMS Zoo Zoo ("Company," "we," "us," or "our") describes how and why we might collect, store, use, and/or share ("process") your information when you use our services ("Services"), such as when you:
</p>
<p>
Visit our website at https://www.smszoozoo.com, or any website of ours that links to this privacy notice. 
</p>
<p>
Engage with us in other related ways, including any sales, marketing, or events.
</p>
<p>
Questions or concerns? Reading this privacy notice will help you understand your privacy rights and choices. If you do not agree with our policies and practices, please do not use our Services. If you still have any questions or concerns, please contact us at support@smszoozoo.com. 
</p>

<div className='privacy'>
  <h1>
  Summary Of Key Points
  </h1>
  <p>
  This summary provides key points from our privacy notice, but you can find out more details about any of these topics by clicking the link following each key point or by using our table of contents below to find the section you are looking for. You can also click here to go directly to our table of contents. 
  </p>
  <p>
  What personal information do we process? We may process personal information depending on how you interact with SMS Zoo Zoo and the Services, the choices you make, and the products and features you use. 
  </p>
  <p>
  Do we process any sensitive personal information? We do not process sensitive personal information.
  </p>
  <p>
  Do we receive any information from third parties? We may receive information from public databases, marketing partners, social media platforms, and other outside sources. 
  </p>
  <p>
  How do we process your information? We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law.
  </p>
  <p>
  In what situations and with which parties do we share personal information? We may share information in specific situations and with specific third parties. 
  </p>
  <p>
  How do we keep your information safe? We have organizational and technical processes and procedures in place to protect your personal information. 
  </p>
  <p>
  What are your rights? Depending on where you are located geographically, you may have certain rights regarding your personal information. 
  </p>
  <p>
  How do you exercise your rights? You can fill out our data subject request form or contact us. 
  </p>
</div>
</div>
<div className='privacy'>
<div className='mt-5'>
  <h4 >
  1. What Information Do We Collect? 
  </h4>
  <p>
  Personal information you disclose to us: We collect personal information that you voluntarily provide to us when you register on the Services, express an interest in obtaining information, or when you participate in activities on the Services. This includes names, phone numbers, email addresses, job titles, usernames, passwords, mailing addresses, billing addresses, debit/credit card numbers. 
  </p>
  <p>
  Payment Data: If you make purchases, we may collect payment information necessary for processing transactions, such as payment instrument number and the security code associated with your payment. This data is stored by our third-party payment processor.
  </p>
  <p>
  Information automatically collected: We automatically collect information such as your IP address, browser and device characteristics, operating system, and location. This helps us to ensure the security and functionality of our Services.
  </p>
</div>
<div className='mt-5'>
  <h4>
  2. How Do We Process Your Information?  
  </h4>
  <p>
  We process your personal information to manage user accounts, communicate with you, enhance our Services, and comply with legal obligations. 
  </p>
  <p>
  We may process your information to provide customer support, offer promotions, or enhance your experience with SMS Zoo Zoo.
  </p>
</div>
<div className='mt-5'>
  <h4>
  3. What Legal Bases Do We Rely On To Process Your Information?   
  </h4>
  <p>
  Consent: We may process your information with your consent, which you can withdraw at any time. 
  </p>
  <p>
  Legal Obligations: We may process your information to comply with legal obligations. 
  </p>
  <p>
  Contractual Necessity: We process your information to fulfill our contractual obligations with you. 
  </p>
</div>
<div className='mt-5'>
  <h4>
  4. When And With Whom Do We Shared Your Personal Information?  
  </h4>
  <p>
  Business Transfers: In the event of a merger, sale of assets, or acquisition, we may share your personal information with the new company.  
  </p>
  <p>
  Third-Party Service Providers: We may share your information with trusted third-party service providers for processing payments, providing technical support, or offering promotional services.  
  </p>

</div>
<div className='mt-5'>
  <h4>
  5. Do We Use cookies And Other Tracking Technology? 
  </h4>
  <p>
  Yes, we may use cookies and similar technologies to enhance your user experience. You can control cookie settings through your browser. 
  </p>

</div>
<div className='mt-5'>
  <h4>
  6. How Do We Handle Your Social Logins? 
  </h4>
  <p>
  If you choose to register or log in using social media accounts, we may access certain profile information from those platforms, such as your name, email address, and profile picture.
  </p>

</div>
<div className='mt-5'>
  <h4>
  7. How Long Do We Keep Your Information? 
  </h4>
  <p>
  We keep your personal information for as long as necessary to fulfill the purposes outlined in this privacy notice, or as required by law. 
  </p>

</div>
<div className='mt-5'>
  <h4>
  8. How Do We Keep Your Information Safe?  
  </h4>
  <p>
  We implement appropriate security measures to protect your information from unauthorized access. However, no method of transmission over the internet is 100% secure. 
  </p>

</div>
<div className='mt-5'>
  <h4>
  9. Do We Collect Information From Minors?   
  </h4>
  <p>
  We do not knowingly collect data from individuals under 18 years of age. If we learn that we have collected such data, we will delete it immediately. 
  </p>

</div>
<div className='mt-5'>
  <h4>
  10. What Are Your Privacy Rights?   
  </h4>
  <p>
  Depending on your location, you may have certain rights to access, correct, or delete your personal information. You can also opt-out of marketing communications at any time.
  </p>

</div>
<div className='mt-5'>
  <h4>
  11. controls For Do-Not-Track Features    
  </h4>
  <p>
  Currently, we do not respond to Do-Not-Track signals from browsers.
  </p>
  <p>
  Contact Information
  </p>
<p>
If you have any questions or concerns about your privacy, you can contact us at care@smszoozoo.com. 
</p>
</div>
</div>
        </div>
      </section>
    </div>
  )
}

export default Privacy
